var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:('color:' + (_vm.item? 'red' : 'green'))},[_vm._v(" "+_vm._s(_vm.item ? 'Sim' : 'Não')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }